module.exports = __webpack_public_path__ + "img/shopping-cart.d126adf9.svg";